import { Link, NavLink } from 'react-router-dom';
import { useState } from 'react';
import './Contacto.css';
import { useLanguage } from '../i18n/LanguageContext';

export default function Contacto() {
  const { t, lang, toggleLanguage } = useLanguage();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mensaje = `Nombre: ${formData.name}%0AEmail: ${formData.email}%0ATeléfono: ${formData.phone}%0AMensaje: ${formData.message}`;
    window.open(`https://wa.me/50662857770?text=${mensaje}`, '_blank');
    setSubmitted(true);
    setFormData({ name: '', email: '', phone: '', message: '' });
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="app">
      <header className="page-hero">
        <nav className="nav">
          <Link to="/" className="brand-link">
            <img
              src="/ceam-logo.png"
              className="brand-logo"
              alt="Centro Educativo Adventista de Monteverde"
            />
            <div className="brand-text">
              <span className="brand-title">{t('common.brand')}</span>
              <span className="brand-subtitle">{t('common.schoolName')}</span>
            </div>
          </Link>
          <div className="nav-actions">
            <NavLink to="/" className="btn ghost">{t('nav.home')}</NavLink>
            <NavLink to="/admisiones" className="btn ghost">{t('nav.admissions')}</NavLink>
            <NavLink to="/acerca-de" className="btn ghost">{t('nav.about')}</NavLink>
            <NavLink to="/ubicacion" className="btn ghost">{t('nav.contact')}</NavLink>
            <NavLink to="/voluntariado" className="btn ghost">{t('nav.volunteer')}</NavLink>
            <button type="button" className="btn ghost lang-toggle" onClick={toggleLanguage}>
              {lang === 'es' ? 'EN' : 'ES'}
            </button>
          </div>
        </nav>
      </header>

      <section className="section contact-page">
        <div className="contact-card-large">
          <h1>{t('contact.title')}</h1>
          <p className="contact-lead">{t('contact.lead')}</p>

          <div className="contact-content">
            <form onSubmit={handleSubmit} className="contact-form-large">
              {submitted && <div className="success-message">{t('contact.success')}</div>}
              
              <div className="form-group">
                <label htmlFor="name">{t('contact.name')}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.namePlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">{t('contact.email')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.emailPlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">{t('contact.phone')}</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder={t('contact.phonePlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">{t('contact.message')}</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.messagePlaceholder')}
                  rows="5"
                ></textarea>
              </div>
              
              <button type="submit" className="btn primary btn-large">{t('contact.send')}</button>
            </form>

            <div className="contact-info-section">
              <h2>{t('contact.infoTitle')}</h2>
              <p className="info-item">
                <strong>{t('contact.hours')}</strong> 8:00 a.m. - 4:00 p.m.
              </p>
              <p className="info-item">
                <strong>{t('contact.enrollmentOpen')}</strong> - {t('contact.enrollmentInvite')}
              </p>

              <div className="contact-methods">
                <div className="method">
                  <h4>📱 WhatsApp</h4>
                  <a href="https://wa.me/50662857770" target="_blank" rel="noopener noreferrer">
                    +506 6285 7770
                  </a>
                </div>
                <div className="method">
                  <h4>📧 {t('contact.address')}</h4>
                  <a href="mailto:info@ceam.ed.cr">
                    info@ceam.ed.cr
                  </a>
                </div>
                <div className="method">
                  <h4>💰 {t('common.accounting')}</h4>
                  <a href="mailto:contabilidad@ceam.ed.cr">
                    contabilidad@ceam.ed.cr
                  </a>
                </div>
                <div className="method">
                  <h4>🌐 {t('contact.web')}</h4>
                  <a href="https://www.ceam.ed.cr" target="_blank" rel="noopener noreferrer">
                    www.ceam.ed.cr
                  </a>
                </div>
                <div className="method">
                  <h4>{t('common.facebook')}</h4>
                  <a href="https://www.facebook.com/CEAdventistaM?locale=es_LA" target="_blank" rel="noopener noreferrer">
                    @CEAdventistaM
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>{t('footer.rights')}</p>
      </footer>
    </div>
  );
}
